import Vue from 'vue'
import Cookie from 'js-cookie'
import Router from 'vue-router'
import Bus from '../utils/eventBus'
import { isPC } from '../utils/getIsPC'
import CookieUtil from '../utils/cookieUtil'
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '',
    redirect: 'home'
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('@/pages/home'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'science',
    path: '/science',
    component: () => import('@/pages/solution/science')
  },
  {
    name: 'AI',
    path: '/AI',
    component: () => import('@/pages/solution/AI')
  },
  {
    name: 'spaceflight',
    path: '/spaceflight',
    component: () => import('@/pages/solution/spaceflight')
  },
  {
    name: 'product',
    path: '/product',
    component: () => import('@/pages/product'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'BusinessCooperation',
    path: '/BusinessCooperation',
    component: () => import('@/pages/BusinessCooperation'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'competitionApply',
    path: '/competitionApply',
    component: () => import('@/pages/competitionApply'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'socialResponsibility',
    path: '/socialResponsibility',
    component: () => import('@/pages/socialResponsibility'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'openHarmony',
    path: '/openHarmony',
    component: () => import('@/pages/openHarmony'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'downloadResources',
    path: '/downloadResources',
    component: () => import('@/pages/downloadResources'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'businessLicense',
    path: '/businessLicense',
    component: () => import('@/pages/businessLicense'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'evaluating',
    path: '/evaluating',
    component: () => import('@/pages/evaluating'),
    meta: {
      noAuth: true
    }
  },
  {
    name: 'news_details',
    path: '/news_details',
    component: () => import('@/pages/news_details'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/course',
    component: () => import('@/pages/course'),
    meta: {
      auth: true,
      noFooter: true
    }
  },
  {
    path: '/loginCb',
    name: 'name',
    component: () => import('@/pages/loginCb/loginCb'),
    meta: {
      noHeader: true,
      noAuth: true,
      noLnav: true,
      noFooter: true,
      noRnav: true
    }
  },
  {
    path: '/wapLogin',
    name: 'wapLogin',
    component: () => import('@/pages/loginCb/wapLogin'),
    meta: {
      noHeader: true,
      noAuth: true,
      noLnav: true,
      noFooter: true,
      noRnav: true
    }
  },
  {
    path: '/inviteAuth',
    name: 'inviteAuth',
    component: () => import('@/pages/loginCb/inviteAuth'),
    meta: {
      noHeader: true,
      noAuth: true,
      noLnav: true,
      noFooter: true,
      noRnav: true
    }
  }
]
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

let r = new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: constantRouterMap
})

r.beforeEach((to, from, next) => {
  // let historyLength = sessionStorage.getItem('historyLength') ? parseInt(sessionStorage.getItem('historyLength')) : 0
  // if (to.fullPath !== from.fullPath) {
  //   historyLength = historyLength + 1
  //   sessionStorage.setItem('historyLength', historyLength)
  // }
  next()
})
r.afterEach(async (to, from, next) => {
  /* 前端权限拦截，前端根据是否存在token判断，然后每个接口还需要判断权限 */
  if (to.name === 'distributionJump') {
    return
  }
  if (to.meta.auth) {
    /* 如果没有openid */
    if (!Cookie.get('UnionID')) {
      Bus.$emit('logOutEvent')
      if (isPC()) {
        CookieUtil.clear()
        Bus.$emit('scanEvent', {
          show: true
        })
      } else {
        if (['', null, 'null', undefined, 'undefined'].indexOf(Cookie.get('StoreUrl')) === -1) {
          return r.push(`/inviteAuth?type=login&returnUrl=${to.path}`)
        } else {
          return r.push(`/inviteAuth?type=login&returnUrl=${to.path}`)
        }
      }
    }
  } else {
    Bus.$emit('scanEvent', {
      show: false
    })
    Bus.$emit('mobileEvent', {
      show: false
    })
  }
})
export default r



// WEBPACK FOOTER //
// ./src/router/index.js